import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { CouponMutationTypes } from '@/core/enum/Coupons/Mutations';
import { CouponActionTypes } from '@/core/enum/Coupons/Actions';
import { Links } from '@/core/enum/Links';

import axios from 'axios';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [CouponActionTypes.POST_COUPON](
    { commit }: AugmentedActionContext,
    payload: any
  ): any;
}

export const actions: ActionTree<State, RootState> & Actions = {
   [CouponActionTypes.POST_COUPON]({ commit }, payload: any) {
    commit(CouponMutationTypes.SET_COUPON_SUCCESS, null);
    commit(CouponMutationTypes.SET_COUPON_ERROR, null);

    return new Promise((res, rej) => {
       axios.post(Links.POST_COUPON, payload)
        .then((result) => {
          res(result.data)
          window.localStorage.setItem('coupon', JSON.stringify(result.data));
          commit(CouponMutationTypes.SET_COUPON_SUCCESS, result.data);
        })
        .catch((error) => {
          rej(error)
          window.localStorage.removeItem('coupon');
          commit(CouponMutationTypes.SET_COUPON_ERROR, error.response.data.message);
        });
    })
  },

};
